export const enum EntryDraftEvents {
    Created = 'EntryDraftCreated',
}

export interface EntryDraftCreatedBody {
    doctorId: string;
    authorId: string;
}

export interface EntryDraftCreatedEventData {
    body: EntryDraftCreatedBody;
    name: EntryDraftEvents;
    entityId: string;
    entityType: 'User';
    occurredOn: string;
}
